import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.BillEmail')
export class BillEmail extends AbstractModel {

    @JsonProperty(String, 'address')
    address: string;
}
